import { UserClaims } from "../../types/users";
import { AuthFilter } from "../auth-filter";
import { ClaimArgBuilder, SecurityRuleFactory, SecurityRuleFactoryWithBuilder, createRule } from "../auth-rules";

// What we will pass in to create this claim - and it's stored structure
export type MaintainProfilesClaimType = string | string[];

// What we will pass in to test if we can view this employee
export type MaintainProfilesClaimArgs = {
  ownerEmail: string;
};

// The test of the claim at runtime - is this user allowed to do this?
const testCan = (claims: UserClaims, callerEmail: string, claim: MaintainProfilesClaimType, args: MaintainProfilesClaimArgs | undefined): boolean => {
  const ownerEmail = args?.ownerEmail;

  const filter = new AuthFilter(claim, ownerEmail);

  return filter.test(callerEmail);
};

export const ruleMaintainProfiles: SecurityRuleFactory<MaintainProfilesClaimType, MaintainProfilesClaimArgs> = () => {
  return createRule("maintain-profiles", testCan);
};

export const ruleMaintainProfilesWithBuilder: SecurityRuleFactoryWithBuilder<MaintainProfilesClaimType, MaintainProfilesClaimArgs> = (argbuilder: ClaimArgBuilder<MaintainProfilesClaimArgs>) => {
  return createRule("maintain-profiles", testCan, argbuilder);
};
